import React from 'react';
import Image from 'react-image'
import { NavLink as Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import NoAvatar from 'assets/images/default-profile.png'
import ThreadStatus from './thread-status';

const Thread = ({
  link,
  username,
  lastMessage,
  date,
  avatar,
  status,
  isRead
}) => {
  return (
    <Link exact={true} to={link} className="block py-2 border-b bg-thread" activeStyle={{ backgroundColor: '#ffffff' }} activeClassName="shadow-md">
      <div className="flex justify-between items-center px-5 text-sm mb-3">
        <ThreadStatus status={status} isRead={isRead} />
        <div className={`date text-xs text-gray-700`}>{date}</div>
      </div>
      <div className="flex items-center">
        <div className="avatar px-2 mr-1">
          <Image src={[avatar, NoAvatar]} className="rounded-full object-cover w-14 h-14" />
        </div>
        <div className="w-3/4 flex flex-col py-2">
          <div className={`username truncate text-base mb-1 ${!isRead ? 'font-bold' : 'font-normal'}`}>{username}</div>
          <div className={`last-message clamp-2 text-xs ${!isRead ? 'font-bold' : 'text-gray-700 font-normal'}`}>{lastMessage}</div>
        </div>
      </div>
    </Link>
  );
}

Thread.propTypes = {
  link: PropTypes.string,
  username: PropTypes.string,
  lastMessage: PropTypes.string,
  date: PropTypes.string,
  avatar: PropTypes.string,
  status: PropTypes.string,
  isRead: PropTypes.bool
};

export default Thread;
